import introJsFn from "intro.js";
import { createElement, onEvent } from "./_dom.js";
import { init as initScrollOffsets } from "./scrollOffsets.js";

const kCompName = "AIInstruction";

let currentScenario = loadStoredScenario(localStorage.getItem('instructionScenario'));
let instructionStep = +localStorage.getItem('instructionStep') || 0;
let instructionPaused = !!localStorage.getItem('instructionPaused');
const suppressedScenarios = localStorage.getItem('instructionSuppressed')?.split(",") || [];

let abortController = null;

function checkValidScenario(scenario) {
	return scenario &&
		typeof scenario === "object" &&
		scenario.name &&
		Array.isArray(scenario.steps) &&
		scenario.steps.length &&
		scenario.steps.every(s => Array.isArray(s) && s.length === 3) ? scenario : null;
}

function loadStoredScenario(scenarioText) {
	try {
		return checkValidScenario(scenarioText && JSON.parse(scenarioText));
	} catch (e) {
	}
	return null;
}

// eslint-disable-next-line no-unused-vars
function getTestScenario(scenarioName) {
	return scenarioName === "setup/columns" ? {
		name: "setup/columns", steps: [
			['*', '#td-appsetup.ui-icon-setup', 'You can modify your database through the Setup menu. Go to it by clicking �Setup�'],
			['setup/tableoverview', '.ui-col.w1 > .hdr', 'Here is Columns menu where you can find links to column-related operations'],
			['setup/tableoverview', 'a[href*="/setup/columnadd.aspx?"]', 'You are in Setup menu. By clicking �Create a new column� you can create new columns for existing tables'],
			['setup/columnadd', '.ui-action-columnideas', 'With our new AI feature you can automatically create new columns by clicking �Suggest Columns�'],
			['setup/columnaddai', '.ui-action-save', 'Save new columns to your table'],
			['setup/tableoverview', '#td-appsetup.ui-icon-back', 'Almost done! Finish setup by�clicking �Exit�Setup�']
		]
	} : null;
}

async function loadRemoteScenario(scenarioName) {
	// return getTestScenario(scenarioName);
	// // eslint-disable-next-line no-unreachable
	try {
		// console.log(kCompName, "Fetching", scenarioName);
		abortController?.abort();
		abortController = new AbortController();
		const response = await fetch(`https://www.teamdesk.net/secure/api/v2/1/Help%20Scenario%20Step/API/select.json?filter=[Link%20Target]="${encodeURIComponent(scenarioName)}"`, {
			headers: { Authorization: `Bearer D40BC82053FF40339314CBCC13430C9D` },
			signal: abortController.signal
		});
		abortController = null;
		const jsonResponse = await response.json();
		if (response.ok) {
			// console.log(kCompName, scenarioName, "fetched");
			return checkValidScenario({ name: scenarioName, version: 1, steps: jsonResponse.map(({ Page, Selector, Text }) => [Page, Selector, Text]) });
		}
		// console.error(kCompName, jsonResponse.code, jsonResponse.source, jsonResponse.message);
	} catch (e) {
		abortController = null;
		// console.error(kCompName, scenarioName, e);
	}
	return null;
}

function updateStepsCount(stepNumber, allSteps) {
	let stepsCount = document.querySelector(".intro-steps-count");
	if (stepsCount == null) {
		stepsCount = createElement("div", { class: 'intro-steps-count' });
		document.querySelector('.introjs-tooltiptext').after(stepsCount);
	}
	stepsCount.replaceChildren(`${stepNumber+1}/${allSteps}`);
}

async function toggleTour(introJs) {
	const newState = setPlayPauseButtonState();
	instructionPaused = newState ? 0 : 1;
	if (instructionPaused) {
		localStorage.setItem("instructionPaused", 1);
		introJs.exit();
	} else if(currentScenario) {
		localStorage.removeItem("instructionPaused");
		await initStep(introJs, instructionStep);
	}
}

function getLocalPath() {
	const basePath = /^.*\/db\/\d+(-\d+)?\//i.exec(location.pathname)[0];
	return location.pathname.substring(basePath.length).replace(/\.aspx$/, "");
}

function canContinuePausedTour() {
	if (currentScenario != null) {
		const localPath = getLocalPath();
		const { steps } = currentScenario;
		// current step is on this page?
		const [ page, elementSelector ] = steps[instructionStep];
		if (page === "*" || page === localPath) {
			const element = document.querySelector(elementSelector);
			if (element)
				return true;
		}
	}
	return false;
}

function dontShowTour(introJs) {
	introJs.exit(true);
	finishScenario(introJs);
}

function setPlayPauseButtonState(playState) {
	const playPauseButton = document.querySelector(".introjs-tour-toggle-button");
	if (playPauseButton) {
		// true -- plays, display pause; false -- paused, display play
		const newState = playState != null ? !!playState : playPauseButton.dataset.icon !== "\uf04c";
		playPauseButton.dataset.icon = newState ? "\uf04c" : "\uf04b";
		const buttonText = newState ? "Pause tutorial" : "Continue tutorial";
		playPauseButton.title = buttonText;
		playPauseButton.querySelector(".ui-icontext").replaceChildren(buttonText);
		return newState;
	}
}

function getOrCreateExitBtns(introJs) {
	let tourButtons = document.querySelector(".introjs-tour-buttons");
	if (!tourButtons) {
		tourButtons = createElement("div", { class: "introjs-tour-buttons" },
			createElement("button", {
				type: "button",
				class: "introjs-tour-toggle-menu-button introjs-tour-button ui-icon-custom ui-icon-only",
				title: "Tutorial Menu",
				"data-icon": "\uf19d", // \uf19d", // graduate-hat
			}, createElement("span", { class: "ui-icontext" }, "Tutorial Menu")),
			createElement("button", {
				type: "button",
				class: "introjs-tour-toggle-button introjs-tour-button ui-icon-custom ui-icon-only",
				title: "Pause tour",
				"data-icon": "\uf04b", // \uf04b - play, \uf04c - pause
				on: {
					click: () => toggleTour(introJs)
				}
			}, createElement("span", { class: "ui-icontext" }, "Pause tour")),
			createElement("button", {
				type: "button",
				class: "introjs-tour-dont-show-button introjs-tour-button ui-icon-custom ui-icon-only",
				title: "End tour",
				"data-icon": "\uf04d", // \uf04d - stop, \uf00d --close
				on: {
					click: () => dontShowTour(introJs)
				}
			}, createElement("span", { class: "ui-icontext" }, "End tour"))
		);
	}
	return tourButtons;
}

function removeExitBtn() {
	return document.querySelector('.introjs-tour-buttons')?.remove();
}

function cleanup(introJs) {
	introJs.setOption("steps", []);
	localStorage.removeItem('instructionScenario');
	localStorage.removeItem('instructionStep');
	localStorage.removeItem('instructionPaused');
	currentScenario = null;
	instructionStep = 0;
	instructionPaused = false;
	removeExitBtn();
}

function isSuppressed(name) {
	return suppressedScenarios.indexOf(name) >= 0;
}

function suppressScenario() {
	if (currentScenario) {
		const { name } = currentScenario;
		if (!isSuppressed(name)) {
			suppressedScenarios.push(name);
			localStorage.setItem('instructionSuppressed', suppressedScenarios.join(","));
		}
	}
}

async function startScenario(introJs, name) {
	if (isSuppressed(name))
		return;
	let scenario = currentScenario;
	if (scenario?.name !== name) {
		scenario = await loadRemoteScenario(name);
		if (scenario == null) {
			cleanup(introJs);
			return false;
		}
	}
	cleanup(introJs);
	currentScenario = scenario;
	localStorage.setItem('instructionScenario', JSON.stringify(currentScenario));
	instructionStep = 0;
	localStorage.setItem('instructionStep', 0);
	instructionPaused = false;
	localStorage.removeItem('instructionPaused');
	await initStep(introJs, 0);
	return true;
}

function finishScenario(introJs) {
	suppressScenario();
	cleanup(introJs);
}

function setNextStep(introJs) {
	if (currentScenario && ++instructionStep < currentScenario.steps.length) {
		localStorage.setItem('instructionStep', instructionStep);
	} else {
		finishScenario(introJs);
	}
}

function initStepUI(introJs, element) {
	const { steps } = currentScenario;
	const forHeader = element.closest("#td-header");
	instructionStep = +introJs._introItems[introJs.currentStep()].step - 1;
	localStorage.setItem('instructionStep', instructionStep);
	updateStepsCount(instructionStep, steps.length);
	const helperLayer = document.querySelector('.introjs-helperLayer');
	helperLayer.after(getOrCreateExitBtns(introJs));
	setPlayPauseButtonState(true);
	const refLayer = document.querySelector(".introjs-tooltipReferenceLayer");
	helperLayer.classList.toggle("introjs-fixedTooltip", !forHeader);
	refLayer.classList.toggle("introjs-fixedTooltip", !forHeader);
	helperLayer.classList.toggle("introjs-forHeader", forHeader);
	refLayer.classList.toggle("introjs-forHeader", forHeader);
}

function initStepsForPage(introJs, page, initialStep) {
	const { steps } = currentScenario;
	let startStep = initialStep, endStep = initialStep;
	let currentStep = 0;
	// find out the range of steps that match current page
	for (; startStep > 0 && steps[startStep - 1][0] === page; startStep--) { /* noop */ }
	for (; endStep < steps.length - 1 && steps[endStep + 1][0] === page; endStep++) { /* noop */ }

	for (let step = startStep, stepIndex = 0; step <= endStep; step++) {
		const [, elementSelector, intro] = steps[step];
		const element = document.querySelector(elementSelector);
		if (element) {
			element.dataset.intro = intro;
			element.dataset.step = step + 1;
			if (step == initialStep) {
				currentStep = stepIndex;
				currentStep = step;
			}
			if("click" in element)
				element.addEventListener("click", () => setNextStep(introJs), { once: true });
			stepIndex++;
		}
	}
	introJs.setOptions({
		showButtons: startStep != endStep
	});
	return currentStep;
}

async function initStep(introJs, step) {
	const { name, steps } = currentScenario;
	const localPath = getLocalPath();
	const initialStep = step;
	const [initialPage, initialElementSelector] = steps[step];
	// if element for step is not found, perhaps we are navigating back?
	for (; step >= 0; step--) {
		const [page, elementSelector] = steps[step];
		if (page === "*" || page === localPath) {
			const element = document.querySelector(elementSelector);
			if (element) {
				const addedStep = initStepsForPage(introJs, page, step);
				await introJs.start();
				await introJs.goToStepNumber(addedStep + 1);
				if (initialStep != step)
					localStorage.setItem('instructionStep', addedStep);
				return;
			}
		}
	}
	console.log(kCompName, `${name}[${initialStep}]: no element for selector: ${initialElementSelector} at ${initialPage}`);
	cleanup(introJs);
}

let suppressNextClickFor = null;

async function clickToStartScenario(introJs, event, el) {
	const { ctrlKey, altKey, metaKey, shiftKey } = event;

	// start on simple primary click, no modifiers
	if (ctrlKey || altKey || metaKey || shiftKey)
		return;

	const { introScenario: scenarioName } = el.dataset;
	if (suppressNextClickFor == null && scenarioName) {
		const clickable = typeof el.click === "function";
		if (clickable)
			event.preventDefault();
		let result = false;
		try {
			document.body.classList.add("introjs-wait-cursor");
			result = await startScenario(introJs, scenarioName);
			// console.log(kCompName, result ? "started" : result == null ? "suppressed" : "failed", scenarioName);
		} finally {
			document.body.classList.remove("introjs-wait-cursor");
		}
		if (!result && clickable) {
			try {
				suppressNextClickFor = el;
				el.click();
			} finally {
				suppressNextClickFor = null;
			}
		}
	}
}

async function doInitAiInstructions(introJs) {

	onEvent(document, "[data-intro-scenario]", "click", (e, el) => clickToStartScenario(introJs, e, el));

	introJs.setOptions({
		showStepNumbers: false,
		showBullets: false,
		showProgress: false,
		showButtons: true,
		exitOnEsc: false,
		hidePrev: true,
		hideNext: true,
	})
	.oncomplete(() => setNextStep(introJs))
	.onafterchange(target => initStepUI(introJs, target));

	// start only if current scenario looks like valid object
	if (currentScenario && instructionStep < currentScenario.steps.length) {
		if (instructionPaused) {
			if (canContinuePausedTour()) {
				document.body.append(getOrCreateExitBtns(introJs));
				setPlayPauseButtonState(false);
			} else {
				// scenario was paused but not on this page
				cleanup(introJs);
			}
		} else {
			await initStep(introJs, instructionStep);
		}
	} else {
		// scenario not found, step is out of range -- clean up
		cleanup(introJs);
	}
}

function toggleRolledTrialtips(trialtipsSection) {
	if (trialtipsSection) {
		const trialtipsHeader = trialtipsSection.querySelector('header');
		const rollUpBtn = trialtipsSection.querySelector('.ui-action-dismiss-tips');
		rollUpBtn.addEventListener('click', (event) => {
			event.preventDefault();
			trialtipsSection.classList.add('small');
		});
		const rollDownBtn = createElement("button", {
			type: "button",
			class: 'trialtips__rolldown-button',
			on: {
				click: (e) => {
					e.preventDefault();
					trialtipsSection.classList.remove('small');
				}
			}
		}, "Expand");
		trialtipsHeader.append(rollDownBtn);
	}
}


function initAiInstructions() {
	toggleRolledTrialtips(document.getElementById('td-trialtips'));
	initScrollOffsets();

	const introJs = introJsFn();
	doInitAiInstructions(introJs);
}

export { initAiInstructions };